<template>
  <div class="youth-articles">
    <SectionLabel text="牽動選情"/>
    <!-- intro -->
    <div class="youth-articles__intro">
      <span>在所有投票權的人口數中，中年以上選民的政黨偏好固定不易鬆動，而年輕族群的政黨色彩較淡，比起黨派更關注議題與政見，因而成為左右選情的關鍵選民。能否翻轉既定政治版圖，就要看哪個陣營能夠獲得年輕族群的青睞。</span>
    </div>
    <!-- headline articles -->
    <div class="youth-articles__headline">
      <div class="youth-articles__item" v-for="article in articlesTop4" :key="article.id">
        <div class="youth-articles__content clearfix">
          <div class="youth-articles__photo"
            is="router-link"
            :to="`/article/${article.id}`"
            :title="article.title"
            :style="`background-image: url(${article.image})`"
            @click="onClick(article.id)">
          </div>
          <div class="youth-articles__overview">
            <div class="youth-articles__head">
              <h3 class="youth-articles__title"
                is="router-link"
                :to="`/article/${article.id}`"
                :title="article.title">{{ article.title }}
              </h3>
              <h4 class="youth-articles__subtitle">{{ article.subtitle }}</h4>
            </div>
            <div class="youth-articles__summary">{{ article.description | ellipsis(150) }}</div>
            <div class="youth-articles__detail"><!--
            --><OutlinesButton :link="`${baseUrl}article/${article.id}`" text="詳細內文" @click.native.prevent="onClick(article.id)"/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SectionLabel from '@/components/SectionLabel'
import OutlinesButton from '@/components/OutlinesButton'
import articles from '@/data/articles'

export default {
  name: 'YouthArticles',
  components: {
    SectionLabel,
    OutlinesButton
  },
  filters: {
    line (text, lineNum = 0) {
      return text.split('\n')[lineNum] || ''
    }
  },
  inject: [ 'baseUrl' ],
  data () {
    return {
      articles
    }
  },
  computed: {
    articlesTop4 () {
      return this.articles.slice(0, 4)
    }
  },
  methods: {
    onClick (id) {
      this.$ga('newmedia.send', {
        'hitType': 'event',
        'eventCategory': 'Link',
        'eventAction': 'Click',
        'eventLabel': `Link-to-article-${id}`
      })
      console.log(`@${this.$options.name} [linktoOtherPage]`)
      this.$router.push({ name: `article-${id}` })
    }
  }
}
</script>

<style lang="scss">
.youth-articles {
  $comp: &;
  @include use-layer(&);
  position: relative;
  min-height: 100vh;
  padding-bottom: 50px;
  background: #e9a8a2;
  @include rwd($RWD_TABLET_SMALL) {
    padding-top: 10px;
    // padding-bottom: 100px;
  }
  @include rwd($RWD_TABLET) {
    padding-top: 30px;
    // padding-bottom: 125px;
  }
  @include rwd($RWD_DESKTOP) {
    // padding-bottom: 100px;
  }
  @include rwd($RWD_DESKTOP_WIDE) {
    padding-bottom: 125px;
  }

  &:before {
    content: "";
    display: block;
    position: absolute;
    top: 75px;
    right: 0;
    width: 150%;
    border: 0.5px solid white;
    transform-origin: top right;
    transform: rotate(-45deg);
    @include rwd($RWD_TABLET_SMALL) {
      top: 100px;
    }
    @include rwd($RWD_TABLET) {
      top: 45px;
    }
  }

  &__intro {
    position: relative;
    margin: 20px 12px;
    font-size: 0.875em;
    font-weight: 600;
    font-family: "Noto Serif TC";
    line-height: 1.7142em;
    letter-spacing: 0.1em;
    @include rwd($RWD_TABLET_SMALL) {
      margin: 30px 36px;
      font-size: 1em;
      line-height: 1.625em;
    }
    @include rwd($RWD_TABLET) {
      width: 520px;
      margin: 40px auto 0;
      font-size: 1.125em;
      line-height: 1.667em;
    }
    @include rwd($RWD_DESKTOP) {
      width: 770px;
      margin: 30px auto 0;
    }
    @include rwd($RWD_DESKTOP_WIDE) {
      width: 910px;
      margin: 55px auto 0;
    }
  }

  &__headline {
    @include rwd($RWD_TABLET_SMALL) {
      width: 520px;
      margin: 0 auto;
    }
    @include rwd($RWD_DESKTOP) {
      width: 850px;
    }
    @include rwd($RWD_DESKTOP_WIDE) {
      width: 86%;
      max-width: 1150px;
    }
    @include rwd($RWD_DESKTOP_WIDE_1660) {
      width: 1440px;
      max-width: none;
    }

    #{$comp}__item {
      margin-top: 46px;
      background: #f9f9f9;
      @include rwd($RWD_TABLET_SMALL) {
        margin-top: 70px;
      }
      @include rwd($RWD_TABLET) {
        margin-top: 70px;
      }
      @include rwd($RWD_DESKTOP) {
        margin-top: 40px;
      }
      @include rwd($RWD_DESKTOP_WIDE) {
      }

      &:before {
        content: "";
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 160px;
        background: #a0d1c6 url(~@/assets/background-pattern.png) repeat top left;

        @include rwd($RWD_TABLET_SMALL) {
          height: 220px;
        }
        @include rwd($RWD_DESKTOP) {
          width: 131px;
          height: 100%;
        }
        @include rwd($RWD_DESKTOP_WIDE) {
          // width: 210px;
          margin-top: -30px;
        }
      }

      &:first-child {
        margin-top: 51px;
        @include rwd($RWD_TABLET_SMALL) {
          margin-top: 70px;
        }
        @include rwd($RWD_TABLET) {
          margin-top: 65px;
        }
        @include rwd($RWD_DESKTOP) {
          margin-top: 40px;
        }
        @include rwd($RWD_DESKTOP_WIDE) {
          margin-top: 90px;
        }
        @include rwd($RWD_DESKTOP_WIDE) {
          margin-top: 140px;
        }
      }

      #{$comp}__photo {
        @include rwd($RWD_DESKTOP) {
          width: 54.55%;
        }
        @include rwd($RWD_DESKTOP_WIDE) {
          top: -30px;
          width: 53.15%;
        }
        @include rwd($RWD_DESKTOP_WIDE_1660) {
          top: -66px;
        }
      }

      #{$comp}__overview {
        @include rwd($RWD_DESKTOP) {
          width: 45.45%;
          height: 100%;
          padding: 5px 0;
        }
        @include rwd($RWD_DESKTOP_WIDE) {
          padding: 53px 0 40px 0;
          width: 46.85%;
        }
        @include rwd($RWD_DESKTOP_WIDE_1660) {
          padding: 95px 0 40px 0;
        }
      }

      #{$comp}__detail {
        .outlines-button {
          @include rwd($RWD_DESKTOP) {
            position: absolute;
            bottom: 40px;
          }
          @include rwd($RWD_DESKTOP_WIDE) {
            // bottom: 66px;
          }
        }
      }

      // odd
      &:nth-child(2n + 1) {
        #{$comp}__photo {
          @include rwd($RWD_DESKTOP) {
            float: left;
          }
        }
        #{$comp}__overview {
          @include rwd($RWD_DESKTOP) {
            float: right;
            padding-left: 50px;
          }
          @include rwd($RWD_DESKTOP_WIDE_1660) {
            padding-left: 85px;
          }
        }
        #{$comp}__detail {
          .outlines-button {
            @include rwd($RWD_DESKTOP) {
              right: 40px;
            }
            @include rwd($RWD_DESKTOP_WIDE) {
              right: 65px;
            }
            @include rwd($RWD_DESKTOP_WIDE_1660) {
              right: 85px;
            }
          }
        }
      }

      // even
      &:nth-child(2n) {
        &:before {
          @include rwd($RWD_DESKTOP) {
            left: auto;
            right: 0;
          }
        }
        #{$comp}__photo {
          @include rwd($RWD_DESKTOP) {
            float: right;
          }
        }
        #{$comp}__overview {
          @include rwd($RWD_DESKTOP) {
            float: left;
            padding-right: 25px;
          }
        }
        #{$comp}__detail {
          .outlines-button {
            @include rwd($RWD_DESKTOP) {
              right: 54.55%;
              margin-right: 25px;
            }
          }
        }
      }

      &:first-child {
      }

      // list mode
      & + #{$comp}__item {
        @include rwd($RWD_DESKTOP_WIDE) {
          display: inline-block;
          width: 33.33%;
          margin-top: 115px;
          vertical-align: top;
          background: transparent;
        }

        &:before {
          @include rwd($RWD_DESKTOP_WIDE) {
            top: 88px;
            left: auto;
            right: auto;
            width: 100%;
            height: 300px;
            margin: 0;
          }
        }

        #{$comp}__content {
          @include rwd($RWD_DESKTOP_WIDE) {
            margin: 0 30px;
            padding: 0;
            background: #f9f9f9;
          }
        }

        #{$comp}__photo {
          @include rwd($RWD_DESKTOP_WIDE) {
            float: none;
            top: 0;
            width: auto;
            margin-top: 0;
          }
        }

        #{$comp}__overview {
          @include rwd($RWD_DESKTOP_WIDE) {
            float: none;
            width: auto;
            padding: 35px 20px 45px 20px;
          }
          @include rwd($RWD_DESKTOP_WIDE) {
            padding: 40px 38px 45px 38px;
          }
        }

        #{$comp}__detail {
          @include rwd($RWD_DESKTOP_WIDE) {
            margin-top: 20px;
            text-align: right;
          }
          .outlines-button {
            @include rwd($RWD_DESKTOP_WIDE) {
              position: relative;
              right: auto;
              bottom: auto;
              margin-right: 0;
              text-align: center;
            }
          }
        }

        #{$comp}__summary {
          @include rwd($RWD_DESKTOP_WIDE) {
            font-size: 1em;
            line-height: 1.875em;
          }
        }

        &:nth-child(2n + 1) {
          #{$comp}__content {
            @include rwd($RWD_DESKTOP_WIDE) {
              margin-top: 35px;
            }
            @include rwd($RWD_DESKTOP_WIDE_1660) {
              margin-top: 46px;
            }
          }
        }
      }
    }
  }

  &__item {
    position: relative;
  }

  &__content {
    position: relative;
    top: -12px;
    padding: 0 12px;

    @include rwd($RWD_TABLET_SMALL) {
      top: -17px;
      padding: 0 36px;
    }
    @include rwd($RWD_DESKTOP) {
      top: auto;
      padding: 40px;
    }
    @include rwd($RWD_DESKTOP_WIDE) {
      padding: 0 65px;
    }
    @include rwd($RWD_DESKTOP_WIDE_1660) {
      padding: 0 85px;
    }
  }

  &__photo {
    display: block;
    position: relative;
    background: #f1f1f1 no-repeat top center / cover;
    cursor: pointer;
    @include use-fixed-ratio(4, 3);
  }

  &__overview {
    padding: 28px 18px 31px 18px;
    color: #1a1a1a;

    @include rwd($RWD_TABLET_SMALL) {
      padding: 31px 8px;
    }
  }

  &__title {
    color: #1a1a1a;
    font-size: 1.25em;
    font-weight: bold;
    line-height: 1.2em;
    letter-spacing: 0.1em;
    @include rwd($RWD_TABLET_SMALL) {
      font-size: 1.5em;
      line-height: 1.25em;
    }
    @include rwd($RWD_TABLET) {
      font-size: 1.875em;
      line-height: 1.2em;
    }
    @include rwd($RWD_DESKTOP) {
      font-size: 1.5em;
      line-height: 1.5em;
    }
    @include rwd($RWD_DESKTOP_WIDE) {
    }
    @include rwd($RWD_DESKTOP_WIDE_1660) {
      font-size: 1.875em;
      line-height: 1.2em;
    }
  }

  &__subtitle {
    margin-top: 10px;
    color: #a51414;
    font-size: 1em;
    font-weight: bold;
    line-height: 1.25em;
    letter-spacing: 0.1em;
    @include rwd($RWD_TABLET_SMALL) {
      margin-top: 5px;
      font-size: 1.125em;
      line-height: 2em;
    }
    @include rwd($RWD_TABLET) {
      margin-top: 10px;
      font-size: 1.25em;
      line-height: 1.5em;
    }
    @include rwd($RWD_DESKTOP) {
      margin-top: 5px;
      font-size: 1.125em;
      line-height: 1.667em;
    }
    @include rwd($RWD_DESKTOP_WIDE) {
      margin-top: 10px;
      font-size: 1.25em;
      line-height: 1.4em;
    }
    @include rwd($RWD_DESKTOP_WIDE_1660) {
      font-size: 1.375em;
      line-height: 1.363em;
    }
  }

  &__summary {
    margin-top: 10px;
    font-size: 0.875em;
    font-weight: bold;
    text-align: justify;
    text-justify: inter-word;
    line-height: 1.714em;
    letter-spacing: 0.1em;
    @include rwd($RWD_TABLET_SMALL) {
      margin-top: 5px;
      font-size: 1em;
      line-height: 1.714em;
    }
    @include rwd($RWD_TABLET) {
      margin-top: 13px;
      font-size: 1.125em;
      line-height: 1.667em;
    }
    @include rwd($RWD_DESKTOP) {
      margin-top: 10px;
      font-size: 1em;
      line-height: 1.5em;
      // max-height: 9em;
      overflow: hidden;
    }
    @include rwd($RWD_DESKTOP_WIDE) {
      margin-top: 13px;
      font-size: 1.125em;
      line-height: 1.667em;
      // max-height: 8em;
    }
  }

  &__detail {
    width: 100%;
    margin-top: 32px;
    text-align: center;
    @include use-vertical-align();

    .outlines-button {
      vertical-align: middle;
      @include rwd($RWD_DESKTOP_WIDE) {
        width: 160px;
        height: 45px;
      }
      &__text {
        @include rwd($RWD_DESKTOP_WIDE) {
          font-size: 1.125em;
        }
      }
    }
  }
}
</style>
